import Box from "@mui/material/Box";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { type GetPPDetailResponse } from "@repo/api";
import { Icons } from "@repo/ui";
import coinsImage from "@repo/ui/assets/images/coins.png";
import { type FC } from "react";
import { useContractId } from "../../context/ContractIDContext";
import { usePensionDetail } from "../../queryHooks";
import EvaluationsContributionsChart from "../Charts/EvaluationsContributionsChart";
import HelpBox from "../InfoBox/HelpBox";
import ProductOverview from "../Overview/ProductOverview";

const Export: FC = () => {
	const { contractId: id } = useContractId();
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down("md"));
	const result = usePensionDetail<GetPPDetailResponse>({ id });

	return (
		<>
			{isMobile && (
				<ProductOverview
					image={coinsImage}
					icon={
						<Icons.Shield sx={{ width: "2.5rem", height: "2.9rem", mr: 4 }} />
					}
					totalSavings={result.isSuccess && result.data.savedAmount}
					claimedSavings={
						result.isSuccess && (result.data.paidOutAmount ?? undefined)
					}
					sx={{
						mx: -4,
					}}
				/>
			)}
			<Box sx={{ width: { md: "50%" } }}>
				<EvaluationsContributionsChart />
			</Box>
			<HelpBox noImage={false} />
		</>
	);
}

export default Export;
